<template>
    <div>
        <van-nav-bar
                title="收货通知列表"
                left-text=""
                left-arrow
                fixed
                @click-left="back()"
                v-if="show"
        />
        <div style="margin-top: 46px">
            <van-search
                    v-model="key"
                    show-action
                    placeholder="送货车号/收货单号"
                    @search="onSearch"
                    clearable
                    left-icon=""
            >
                <template #action>
                    <div @click="onSearch">
                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>
                    </div>
                </template>
            </van-search>
        </div>

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onSearch">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell class="swipewarp" @click="showBill(item)" v-for="item in list" :key="item.id" >
                        <van-row gutter="20">
                            <van-col span="14" class="ellipsis">
                                单号：{{item.arrivalNo}}
                            </van-col>
                            <van-col span="10" class="ellipsisRight">
                                车号：{{item.deliveryVehicleNo}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12" class="ellipsis">
                                日期：{{item.arrivalDate  |moment("YYYY-MM-DD")}}
                            </van-col>
                            <van-col span="12" class="ellipsisRight">
                                仓库：{{item.wcode}}
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>




        <div class="van-address-list__bottom">
            <van-button block  type="info" native-type="submit" class="button" @click="showNew(true)">
                新建
            </van-button>
        </div>


        <van-popup v-model="detailPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title="收货通知详情"
                    left-text=""
                    left-arrow
                    fixed
                    @click-left="showDetail(false)"
                    v-if="show"
            />

            <div style="height:calc(100vh - 96px); overflow: auto;margin-top: 46px">
                <van-pull-refresh >

                        <div class="van-doc-demo-block">
                            <van-row>
                                <van-col span="10"><h2 class="van-doc-demo-block__title">{{arrival.arrivalNo}}</h2></van-col>
                                <van-col span="14"><h2 class="van-doc-demo-block__title" style="text-align: right">
                                    {{arrival.status |statusC}}
                                </h2></van-col>
                            </van-row>
                            <div class="van-cell-group van-hairline--bottom">
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>收货日期</span></div>
                                    <div class="van-cell__value"><span>{{arrival.arrivalDate | moment("YYYY-MM-DD")}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>货主</span></div>
                                    <div class="van-cell__value"><span>{{arrival.customerName}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>送货车号</span></div>
                                    <div class="van-cell__value"><span>{{arrival.deliveryVehicleNo}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>收货仓库</span></div>
                                    <div class="van-cell__value"><span>{{arrival.wcode}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>备注</span></div>
                                    <div class="van-cell__value"><span>{{arrival.remarks}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>创建人</span></div>
                                    <div class="van-cell__value"><span>{{arrival.createPersonName}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>创建时间</span></div>
                                    <!--<div class="van-cell__value"><span>{{arrival.confirmPersonName}}一一{{arrival.confirmTime}}</span></div>-->
                                    <div class="van-cell__value"><span> {{arrival.createTime}}</span></div>
                                </div>
                            </div>

                        </div>
                </van-pull-refresh>
            </div>




            <div class="van-psichase-detail__bottom">
                <van-button block  type="info" native-type="submit" class="button" @click="showdel()">
                    删除
                </van-button>
                <van-button block  type="info" native-type="submit" class="button" @click="showUpd()">
                    修改
                </van-button>

            </div>


        </van-popup>

        <van-popup v-model="newPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title="收货指令新建"
                    left-text=""
                    left-arrow
                    fixed
                    @click-left="showNew(false)"
                    v-if="show"
            />

            <div style="height:calc(100vh - 50px); overflow: auto;" class="address">

                <div class="van-doc-demo-block">
                    <h2 class="van-doc-demo-block__title">收货作业信息</h2>
                    <!--                <div role="separator" class="van-divider van-divider&#45;&#45;hairline"> </div>-->
                </div>
                <van-field  readonly name="picker" :disabled="!isadd" label="收货日期" placeholder="点击选择日期" :value="arrivalAdd.arrivalDate"  required
                            @click="showPicker('arrivalDateMode')"
                            label-width="100px" label-align="right"/>

                <van-field  label="货主" :disabled="!isadd" @click="showPicker('showPickerCustomer')" placeholder="请选择货主" autocomplete="off" readonly required
                            label-width="100px" label-align="right"    v-model="customerName">
                    <template #button >
                        <van-icon name="arrow"     />
                    </template>
                </van-field>

                <van-field  label="收货仓库" placeholder="请选择仓库" autocomplete="off" v-model="warehouseName" required
                            @click="showPicker('showPickerWarehouse')"
                            label-width="100px" label-align="right">
                    <template #button >
                        <van-icon name="arrow" />
                    </template>
                </van-field>


                <van-field  label="送货车号" placeholder="请输入车牌号码" autocomplete="off" v-model="arrivalAdd.deliveryVehicleNo" required
                            label-width="100px" label-align="right"/>
                <van-field label-align="right" label-width="100px"
                           v-model="arrivalAdd.remarks"
                           rows="1"
                           autosize="true"
                           label="备注"
                           type="textarea"
                           placeholder="请输入要求"
                />

            </div>


            <van-calendar v-model="arrivalDateMode"
                          :min-date=" new Date()"
                          :default-date="new Date()"
                          type="single" @confirm="calendarConfirm"/>


            <van-popup v-model="showPickerCustomer" position="bottom" :style="{ height: '310px' }">
                <van-picker
                        title="货主"
                        show-toolbar
                        :columns="customerIds"
                        @confirm="customerVal"
                        @cancel="showPickerCustomer = false"
                />
            </van-popup>

            <van-popup v-model="showPickerWarehouse" position="bottom" :style="{ height: '310px' }">
                <van-picker
                        title="仓库"
                        show-toolbar
                        :columns="warehouseIds"
                        @confirm="warehouseVal"
                        @cancel="showPickerWarehouse = false"
                />
            </van-popup>



            <div class="van-address-list__bottom">
                <van-button block  type="info" native-type="submit" class="button" @click="save()">
                    保存
                </van-button>
            </div>


        </van-popup>

    </div>
</template>

<script>
    import Vue from 'vue'
    import commonUtil from "@/utils/commonUtil";
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import { Dialog} from 'vant';
    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                isadd:true,
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                //详情pop
                detailPop: false,
                newPop: false,
                key:"",
                arrivalAdd:{},
                arrival:{},
                customerIds: [],
                customerData : [],
                customerName:"",
                warehouseName:"",
                warehouseIds:[],
                warehouseData:[],
                showPickerCustomer:false,
                showPickerWarehouse:false,
                arrivalDateMode:false,

            }
        },
        mounted() {

            this.onLoad();
            let param = {};
            param.ouid = localStorage.getItem("ouid")
            service.selOuCustomerG(param).then(res => {
                let data = res.data;
                this.customerData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.customerIds.push(data[i].orgunitName)
                }
            })
            service.selWarehouseG(param).then(res => {
                let data = res.data;
                this.warehouseData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.warehouseIds.push(data[i].wcode)
                }
            })
        },

        methods: {

            showdel(){


                Dialog.confirm({
                    title: '提示消息',
                    message: '确定删除吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.delJGArrival({arrivalId: this.arrival.arrivalId}).then(res => {
                        if (res.code == "200") {
                            Toast("删除成功")
                            this.detailPop = false;
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })


            },

            showUpd(){
                this.newPop = true;
                this.isadd=false
                let data=this.arrival
                data.arrivalDate=Vue.prototype.$moment(new Date(data.arrivalDate)).format('YYYY-MM-DD')
                this.customerName=this.customerData.filter(function (item) {
                    return data.customerId == item.customerId
                })[0].orgunitName

                this.warehouseName=this.warehouseData.filter(function (item) {
                    return data.warehouseId == item.warehouseId
                })[0].wcode


                this.arrivalAdd=data



            },

            showBill(data)
            {
                let arrivalId=data.arrivalId
                let param={}
                param.arrivalId=arrivalId

                service.selJGArrivalById(param).then((res) => {
                    if (res.code == "200"){

                        let data = res.data;
                        this.arrival=data
                    }
                })


                this.detailPop = true;
            },
            calendarConfirm(date) {
                this.arrivalDateMode = false;
                this.arrivalAdd.arrivalDate = this.$moment(date).format("YYYY-MM-DD")
            },
            customerVal(value, index){
                this.customerName = value;
                this.arrivalAdd.customerId = this.customerData[index].customerId
                this.showPickerCustomer = false;
            },

            warehouseVal(value, index){
                this.warehouseName = value;
                this.arrivalAdd.warehouseId = this.warehouseData[index].warehouseId
                this.showPickerWarehouse = false;
            },

            showPicker(pickerName){
                this.arrivalDateMode = false
                this.showPickerCustomer=false
                this.showPickerWarehouse=false
                switch (pickerName) {
                    case 'arrivalDateMode':
                        this.arrivalDateMode = true
                        break
                    case 'showPickerCustomer':
                        this.showPickerCustomer = true
                        break
                    case 'showPickerWarehouse':
                        this.showPickerWarehouse = true
                        break

                }


            },

            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/cangAll")
            },
            addPop() {
                this.show = true;
            },

            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.onLoad();
            },
            showDetail(flag) {
                this.detailPop = flag;
            },
            showNew(flag) {
                this.newPop = flag;
                this.arrivalAdd={}
                this.isadd=true
                this.customerName=""
                this.warehouseName=""
                this.arrivalAdd.arrivalDate = this.$moment(new Date()).format("YYYY-MM-DD")
            },
            onLoad() {
                let param = {}
                param.limit = 10
                param.page = this.page
                param.key = this.key
                param.ouid = localStorage.getItem("ouid")
                service.selJGArrivalP(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }

                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },
            save(){

                if(this.arrivalAdd.customerId=="" || this.arrivalAdd.customerId==undefined )
                {
                    Toast('请指定货主')
                    return
                }

                if(this.arrivalAdd.warehouseId=="" || this.arrivalAdd.warehouseId==undefined)
                {
                    Toast('请输入收货仓库')
                    return
                }

                if(this.arrivalAdd.deliveryVehicleNo=="" || this.arrivalAdd.deliveryVehicleNo==undefined)
                {
                    Toast('请输入送货车号')
                    return
                }else
                {
                    let express =
                        /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
                    if (!express.test(this.arrivalAdd.deliveryVehicleNo)) {
                        Toast('请输入正确格式的提货车号')
                        return false;
                    }

                }

                if(this.isadd)
                {
                    let parm=this.arrivalAdd;

                    parm.createPersonId=localStorage.getItem("personId")
                    parm.createTime=commonUtil.getCurrentTime();
                    parm.ouid=localStorage.getItem("ouid")
                    parm.arrivalDetails=[]
                    service.addJGArrival(parm).then(res=>{
                        console.log(res)
                        if(res.code == "200")
                        {
                            Toast("保存成功")
                            this.newPop = false
                            this.onSearch()

                        }else
                        {
                            Toast("保存失败"+res.data.msg)
                        }


                    })

                }else
                {

                    let parm=this.arrivalAdd;
                    parm.ouid=localStorage.getItem("ouid")
                    parm.arrivalDetails=[]
                    parm.addArrivalDetails=[]
                    parm.delArrivalDetails=[]
                    parm.updArrivalDetails=[]
                    service.updJGArrival(parm).then(res=>{
                        if(res.code == "200")
                        {
                            Toast("修改成功")
                            this.newPop = false
                            this.onSearch()

                        }else
                        {
                            Toast("修改成功"+res.data.msg)
                        }


                    })


                }



            }




        },
        filters:{
            statusC: function (value) {
                if(value == 10)
                {
                    return '新建'
                }
                if(value ==30)
                {
                    return '收货'
                }
                if(value == 40)
                {
                    return '完结'
                }

            },
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .contentwarp {
        margin-top: 0px;
        height: calc(100vh - 204px);
        overflow: auto;
        /*height: 550px;*/
    }
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
    .van-panel__content dd{
        margin-inline-start: 0px;
        font-size: 14px;
    }
    .van-panel__content dt{
        font-size: 14px;
        font-weight: bold;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 15px;
        line-height: 16px;
        text-align: left;
    }
    /deep/ .van-cell__title{
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex:unset;
        flex:unset;
        width: 90px;
        color: #969799;
    }
    /deep/ .van-cell__value{
        color: #323233;
    }
    .van-list .van-cell-group::after {
        border-bottom-width: 5px;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right{
        text-align: right;
    }
    .van-psichase-detail__bottom{
        display:-webkit-box;
    }
    .van-psichase-detail__bottom .button{
        -webkit-box-flex:1;
    }
    /deep/ .psichase-new-pic .van-image{
        position: relative;
    }
    .van-uploader__preview-delete {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: rgba(0,0,0,.7);
        border-radius: 0 0 0 12px;
    }
    /deep/ .psichase-new-pic .van-icon.van-icon-cross{
        position: absolute;
        top:0;
        right: 0;
        color: #fff;
        font-size: 16px;
        transform: scale(.7) translate(10%,-10%);
    }
    /deep/ .van-grid-item__content{
        padding: 8px;
    }
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }
    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 50px;
        border: 1px solid white;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right {
        text-align: left;
    }
    /deep/ .address .van-cell {
        padding: 8px 16px 8px 20px;
    }
    .van-cell{
        padding: 8px 16px;
        font-size: 15px;
    }
    /deep/ .van-cell .van-field__control{
        font-size: 15px;
    }
</style>
